export default "__VITE_ASSET__DUJ7bznI__"